/**
 * Model class for an Alert of the system.
 */
export default class TMAlert {
  public title: string = '';

  public message: string = '';

  public state: boolean = false;

  public width: number = 300;

  constructor(obj?: { title: string; message: string; width?: number; state: boolean }) {
    if (obj !== undefined) {
      this.title = obj.title;
      this.message = obj.message;
      this.state = obj.state;
      this.width = obj.width || 300;
    }
  }
}
